import type { ReactNode } from "react";
import { ModelBillingOverview } from "./overview";
import { TierGrid } from "./tier-grid";
import type { GridViewProps } from "./types";

export function GridView({
  tiers,
  description,
  modelName,
}: GridViewProps): ReactNode {
  return (
    <div className="grid grid-cols-12 gap-8">
      <div className="col-span-full xl:col-span-4">
        <ModelBillingOverview modelName={modelName} description={description} />
      </div>
      <div className="col-span-full xl:col-span-8 @container">
        <div className="@lg:grid @lg:grid-cols-2 @lg:space-y-0 space-y-4 gap-x-4 gap-y-8">
          <TierGrid tiers={tiers} />
        </div>
      </div>
    </div>
  );
}
